import script from "./CourseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseDetail.vue?vue&type=script&setup=true&lang=js"

import "./CourseDetail.vue?vue&type=style&index=0&id=93faa306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93faa306"]])

export default __exports__